<template>
    <div>
        <div class="wrapper">

            <dashboard-navigation :myProps="fullname"></dashboard-navigation>
            <dashboard-sidebar :myProp="fullname"></dashboard-sidebar>

            <!-- Full Order Modal -->
            <div class="modal" id="fullOrderModal">
                <div class="modal-dialog">
                    <div class="modal-content">
                    <form>
                        <!-- Modal Header -->
                        <div class="modal-header">
                        <h4 class="modal-title" v-if="stanbic_trustpay_user_role == 'buyer'"><small>{{order.order_code}}</small></h4>
                        <h4 class="modal-title" v-else><small>{{order.id}}</small></h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>

                        <!-- Modal body -->
                        <div class="modal-body">
                        
                        <div class="row">
                                <!--<div class="col-sm-6">
                                    <img src="http://via.placeholder.com/350x150" style="width: 100%; height: auto;" />
                                    <br /><br />
                                </div>-->
                                </div>
                                <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                    <label>Order Number</label>
                                    <br />
                                    <input type="text" readonly="readonly" :value="formatToSixDigits(order.id)" class="form-control" />
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                    <label>Amount</label>
                                    <br />
                                    <input type="text" readonly="readonly" :value="order.amount_payed | currency" class="form-control"/>
                                    </div>
                                </div>
                                <!--
                                <div class="col-sm-6">
                                    <div class="form-group">
                                    <label>Transaction Reference</label>
                                    <br />
                                    <input type="text" readonly="readonly" value="TXd3333o0" class="form-control" />
                                    </div>
                                </div>
                                -->
                                </div>
                                <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                    <label>Order Date</label>
                                    <br />
                                    <input type="text" readonly="readonly" v-model="order.transaction_date" class="form-control" />
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                    <label>Order Status</label>
                                    <br />
                                    <input type="text" readonly="readonly" v-model="order_status.title" class="form-control"/>
                                    </div>
                                </div>
                                </div>
                                <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                    <label>Customer Name</label>
                                    <br />
                                    <input type="text" readonly="readonly" v-model="order_seller" class="form-control"/>
                                    </div>
                                </div>
                                <!--<div class="col-sm-6" v-if="stanbic_trustpay_user_role == 'buyer'">
                                    <div class="form-group">
                                    <label>Order Code</label>
                                    <br />
                                    <input type="text" readonly="readonly" v-model="order.order_code" class="form-control"/>
                                    </div>
                                </div>-->
                                </div>
                                <div class="row" v-if="stanbic_trustpay_user_role == 'seller'">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                    <label>Delivery Location</label>
                                    <br />
                                    <input type="text" readonly="readonly" v-model="order.delivery_location" class="form-control"/>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                    <label>Delivery Date</label>
                                    <br />
                                    <input type="text" readonly="readonly" v-model="order.delivery_date" class="form-control"/>
                                    </div>
                                </div>
                                </div>
                                <br /><br />
                            </div>

                    </form>
                    </div>
                </div>
            </div>

            <!-- Assign Dispatcher Modal -->
            <div class="modal" id="assignDispatcherModal">
                <div class="modal-dialog">
                    <div class="modal-content">
                    <form>
                        <!-- Modal Header -->
                        <div class="modal-header">
                        <h4 class="modal-title"><small>Assign Dispatcher to Order {{ formatToSixDigits(order.id) }}</small></h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>

                        <!-- Modal body -->
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="alert alert-danger assign-danger d-none">
                                        <button type="button" class="close" v-on:click="hideAlert">&times;</button>
                                        <strong>Error!</strong> {{assignError}}
                                    </div>
                                    <div class="alert alert-success assign-success d-none">
                                        <button type="button" class="close" v-on:click="hideAlert">&times;</button>
                                        <strong>Success!</strong> Order {{ formatToSixDigits(order.id) }} has been assigned.
                                    </div>
                                    <p v-if="order.delivery_men != null">
                                        This order is already assigned to {{order.delivery_men.firstname}} {{order.delivery_men.lastname}} ({{order.delivery_men.email}})
                                    </p>
                                    <div class="form-group">
                                    <label>Select Dispatcher</label>
                                    <br />
                                    <select class="form-control" v-model="selectedDispatcher">
                                        <option :value="dispatcher.id" v-for="dispatcher in dispatchers" :key="dispatcher.id" >{{dispatcher.firstname}} {{dispatcher.lastname}} - {{dispatcher.email}}</option>
                                    </select>
                                    <br />
                                    <a class="btn btn-primary" v-on:click="assignDispatcherToOrder()">Assign</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </form>
                    </div>
                </div>
            </div>


            <div class="content-wrapper">
                <!-- Content Header (Page header) -->
                <div class="content-header">
                    <div class="container-fluid">
                        <div class="row mb-2">
                            <div class="col-sm-12">
                                <h1 class="m-0 text-dark">All Orders</h1>
                                <div class="attop"><p>
                                   Here you will find details of all orders created via your online website and Person to Person (P2P) transactions. 
 
Also, from here you are able to assign orders to dispatchers by clicking on the Assign Dispatcher link next to the order. If you have assigned a dispatcher to an order already but wish to reassign another dispatcher to same order, click on the Reassign Dispatcher link to assign another dispatcher
                                </p></div>
                               
                               
                                <br />
                                <p v-if="status == 'no_dispatchers'">You cannot assign a dispatcher to an order yet because you have not registered any dispatchers. Click <router-link to="/myescrow/dispatchers/all">here</router-link> to add dispatchers.</p>
                                <!--
                                <div class="row">
                                    <div class="col-md-4">
                                        <label for="">Filter By</label>
                                          <input type="text" v-bind:placeholder="'Fullname in ' + orders.data.length + ' orders'" class="form-control" v-model="orderDed">
                                    </div>
                                    <div class="col-md-2">
                                        <label for=""></label>
                                        <input type="text" placeholder="Order Id" class="form-control" style="margin-top:5px;" v-model="productSearch">
                                    </div>
                                    <div class="col-md-2">
                                        <label for="" style="font-size: 15px; margin-bottom: 0;">Date From</label>
                                       <input type="date" placeholder="Date e.g(2018-01-01)" class="form-control" style="margin-top:5px;" v-model="orderdate">
                                    </div>
                                    <div class="col-md-2">
                                        <label for="" style="font-size: 15px; margin-bottom: 0;">Date To</label>
                                       <input type="date" placeholder="Date e.g(2018-01-01)" class="form-control" style="margin-top:5px;" v-model="orderdate2">

                                    </div>
                                    <div class="col-md-2">
                                         <label for=""></label>
                                        <button class="btn btn-info btn-block">Filter</button>
                                    </div>
                                </div>
                                -->
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Main content -->
                <section class="content">
                <div class="container-fluid">
                    <br />
                    <div class="row">
                    <div class="col-12 col-sm-12 col-md-12">
                        <div class="alert animated bounceIn alert-danger d-none search-alert">
                            <a class="close alert-close" aria-label="close" v-on:click="hideAlert">&times;</a>
                            <span>{{alertMessage}}</span>
                        </div>
                        <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <!--
                                <div class="col-12 col-sm-3">
                                    <div class="form-group">
                                        <label for="filter">Filter</label>
                                        <input type="text" class="form-control" v-model="filter" placeholder="Filter">
                                    </div>
                                </div>
                                -->
                                
                                <div class="col-12 col-sm-3">
                                    <div class="form-group">
                                        <label for="period">Period</label>
                                        <select class="form-control" v-on:change="filterPeriod()" v-model="period"> 
                                            <option value="All">All</option>
                                            <option value="This Week">This Week</option>
                                            <option value="This Month">This Month</option>
                                            <option value="60 Days Ago">60 Days Ago</option>
                                            <option value="90 Days Ago">90 Days Ago</option>
                                            <option value="Custom">Custom</option>
                                        </select>
                                        
                                    </div>
                                </div>
                                <div class="col-12 col-sm-3">
                                    <div class="form-group">
                                        <label for="from">Date From</label>
                                        <input type="date" class="form-control" v-model="from_date" :disabled="notCustom">
                                    </div>
                                </div>
                                <div class="col-12 col-sm-3">
                                    <div class="form-group">
                                        <label for="from">Date To</label>
                                        <input type="date" class="form-control" v-model="to_date" :disabled="notCustom">
                                    </div>
                                </div>
                                <div class="col-12 col-sm-3">
                                    <div class="form-group">
                                        <label>&nbsp;</label>
                                        <button class="btn btn-primary form-control" :disabled="notCustom" v-on:click="filterDates()">Filter</button>
                                    </div>
                                </div>
                                
                            </div>
                            <br />
                            <div class="table-responsive">
                                <datatable :columns="table_columns" :data="table_rows" :filter-by="filter" class="table" v-if="stanbic_trustpay_user_role == 'seller'">
                                    <template scope="{ row }">
                                        <tr>
                                            <td>
                                                <a style="cursor: pointer;" v-on:click="showSingleOrder(row.id)" >{{formatToSixDigits(row.id)}}</a>
                                            </td>
                                            <td v-if="row.customers != null">
                                                {{row.customers.firstname}} {{row.customers.lastname}}
                                            </td>
                                            <td v-else></td>
                                            <td>{{row.transaction_date}}</td>
                                            <td v-if="row.delivery_men != null">
                                                {{row.delivery_men.firstname}} {{row.delivery_men.lastname}}
                                                <span v-if="row.delivery_men.type == 1">(Independent)</span>
                                                <span v-else-if="row.delivery_men.type == 2">(Seller)</span>
                                                <span v-else-if="row.delivery_men.type == 3">({{row.delivery_men.courier_business.business_name}})</span>
                                            </td>
                                            <td v-else></td>
                                            <td>{{row.status.title}}</td>
                                            <td>
                                                <router-link :to="{ name: 'raise-dispute', params: { orderId: row.id }}" class="text-danger" v-if="row.status.title == 'Disputed'">
                                                <small>Raise Dispute</small>
                                                &nbsp;&nbsp;
                                                </router-link>
                                                
                                                <a v-if="status != 'no_dispatchers' && row.delivery_men != null" style="cursor: pointer;" v-on:click="showAssignDeliveryManModal(row.id)" class="text-primary">
                                                    <small>Reassign Dispatcher</small>
                                                </a>
                                                <a v-if="status != 'no_dispatchers' && row.delivery_men == null" style="cursor: pointer;" v-on:click="showAssignDeliveryManModal(row.id)" class="text-primary">
                                                    <small>Assign Dispatcher</small>
                                                </a>
                                            </td>
                                        </tr>
                                    </template>
                                </datatable>
                                <datatable :columns="customer_columns" :data="table_rows" :filter-by="filter" class="table" v-else>
                                    <template scope="{ row }">
                                        <tr>
                                            <td>
                                                <a style="cursor: pointer;" v-on:click="showSingleOrder(row.id)" >{{formatToSixDigits(row.id)}}</a>
                                            </td>
                                            <td>{{row.sellers.business_name}}</td>
                                            <td>{{row.transaction_date}}</td>
                                            <td>{{row.status.title}}</td>
                                            <td>
                                                <router-link :to="{ name: 'raise-dispute', params: { orderId: row.id }}" class="text-danger">
                                                <small>Raise Dispute</small>
                                                </router-link>
                                            </td>
                                        </tr>
                                    </template>
                                </datatable>
                            </div>
                            <div class="row">
                                <div class="col-xs-12 form-inline">
                                    <datatable-pager v-model="page" type="abbreviated" :per-page="per_page"></datatable-pager>
                                </div>
                            </div>
                            
                            <br />
                        </div>
                    </div>
                    </div>
                    </div>
                    <br />

                </div><!--/. container-fluid -->
                </section>
                <!-- /.content -->
            </div>
            
            <dashboard-footer></dashboard-footer>
            
        </div>
    </div>
</template>

<style>
.content-wrapper{
    min-height: calc(100vh - 110px) !important;
}
.attop{
    background: #F5F5DC !important;
    color: #000 !important;
}
.pagination li a{
    padding: 5px;
    border: 1px solid #ccc;
    width: 38px !important;
    margin: 3px;
    border-radius: 5px;
    display: block;
    text-align: center;
}
.pagination li.active a{
    background: rgb(21, 82, 250);
    color: white;
}
.pagination li:hover a{
    background: rgb(231, 231, 231);
    color: rgb(21, 82, 250);
}
</style>

<script>
const endpoint = 'http://18.208.164.251/api';
export default {

    data(){
        return{
            stanbic_trustpay_user_role: this.$session.get('stanbic_trustpay_user_role'),
            status: null,
            from_date: null,
            to_date: null,
            fullname: "",
            orders: [],
            order: [],
            order_status: "",
            dispatchers: [],
            selectedDispatcher: 0,
            assignError: "",
            filter: '',
            page: 1,
            alertMessage: '',
            notCustom: true,
            period: "All",
            per_page: 10,
            order_seller: "",
            table_columns: [
                {label: 'Order ID', sortable: true},
                {label: 'Customer', sortable: true},
                {label: 'Order Date', sortable: true},
                {label: 'Dispatcher', sortable: true},
                {label: 'Order Status', sortable: true},
                {label: 'Action', sortable: true}
            ],
            customer_columns: [
                {label: 'Order ID', sortable: true},
                {label: 'Seller', sortable: true},
                {label: 'Order Date', sortable: true},
                {label: 'Order Status', sortable: true},
                {label: 'Action', sortable: true}
            ],
            table_rows: [],
            original_rows: []
        };
    },
    methods:{
        filterPeriod: function(){
            console.log(this.period);

            if(this.period == "All"){
                this.table_rows = this.original_rows;
                this.notCustom = true;
                this.page = 1;
                this.to_date = null;
                this.from_date = null;
                return;
            }

            if(this.period == "This Week"){
                var ordersThisWeek = [];

                for(var i = 0; i < this.original_rows.length; i++){
                    var now = moment();
                    var input = moment(this.original_rows[i].transaction_date);
                    var isThisWeek = (now.isoWeek() == input.isoWeek())

                    if(isThisWeek){
                        ordersThisWeek.push(this.original_rows[i]);
                    }
                }

                this.table_rows = ordersThisWeek;
                this.notCustom = true;
                this.page = 1;
                this.to_date = null;
                this.from_date = null;
                return;
            }

            if(this.period == "This Month"){
                var ordersThisMonth = [];

                for(var i = 0; i < this.original_rows.length; i++){
                    //var now = moment();
                    var input = moment(this.original_rows[i].transaction_date);
                    var isThisMonth = input.isSame(new Date(), 'month');

                    if(isThisMonth){
                        ordersThisMonth.push(this.original_rows[i]);
                    }
                }

                this.table_rows = ordersThisMonth;
                this.notCustom = true;
                this.page = 1;
                this.to_date = null;
                this.from_date = null;
                return;
            }

            if(this.period == "60 Days Ago"){
                var ordersSixtyDaysAgo = [];

                for(var i = 0; i < this.original_rows.length; i++){
     
                    var sixty_days_ago = moment().subtract(60, 'days');

                    var isBetweenSixtyDays = moment(this.original_rows[i].transaction_date).isAfter(sixty_days_ago);

                    if(isBetweenSixtyDays){
                        ordersSixtyDaysAgo.push(this.original_rows[i]);
                    }
                }

                this.table_rows = ordersSixtyDaysAgo;
                this.notCustom = true;
                this.page = 1;
                this.to_date = null;
                this.from_date = null;
                return;
            }

            if(this.period == "90 Days Ago"){
                var ordersNinetyDaysAgo = [];

                for(var i = 0; i < this.original_rows.length; i++){
     
                    var ninety_days_ago = moment().subtract(90, 'days');

                    var isBetweenNinetyDays = moment(this.original_rows[i].transaction_date).isAfter(ninety_days_ago);

                    if(isBetweenNinetyDays){
                        ordersNinetyDaysAgo.push(this.original_rows[i]);
                    }
                }

                this.table_rows = ordersNinetyDaysAgo;
                this.notCustom = true;
                this.page = 1;
                this.to_date = null;
                this.from_date = null;
                return;
            }

            if(this.period == "Custom"){
                
                this.to_date = null;
                this.from_date = null;
                this.notCustom = false;
                return;

            }
        },
        filterDates: function(){
            
            if(this.from_date == null){
                this.alertMessage = "Please select a From date";
                $(".search-alert").removeClass("d-none");
            }
            if(this.to_date == null){
                this.alertMessage = "Please select a To date";
                $(".search-alert").removeClass("d-none");
            }

            if(moment(this.from_date).isAfter(this.to_date)){
                this.alertMessage = "Please select a From date that is before your To date";
                $(".search-alert").removeClass("d-none");
            }

            var ordersBetweenTheTwoDates = [];

            for(var i = 0; i < this.original_rows.length; i++){

                var isBetweenDates = moment(this.original_rows[i].transaction_date).isBetween(this.from_date, this.to_date); // true

                if(isBetweenDates){
                    ordersBetweenTheTwoDates.push(this.original_rows[i]);
                }
            }

            this.table_rows = ordersBetweenTheTwoDates;
            //this.notCustom = true;
            this.page = 1;
            //this.to_date = null;
            //this.from_date = null;
            return;
        },
        populateTableWithData: function(array){
            console.log(array);
            //return;
            var returnedArray = [];
            //array.forEach(function(element)
            for(let i = 0; i < array.length; i++){

                let element = array[i];
                var dispatcher_name = "";
                var customer_name = "";

                if(element.delivery_men != null){
                    dispatcher_name = element.delivery_men.firstname + " " + element.delivery_men.lastname;

                    if(element.delivery_men.type == 1){
                        dispatcher_name += " (Independent)";
                    }else if(element.delivery_men.type == 2){
                        dispatcher_name += " (Seller)";
                    }else if(element.delivery_men.type == 3){
                        dispatcher_name += " (" + element.delivery_men.courier_business.business_name + ")";
                    }
                }

                if(element.customers != null){
                    customer_name = element.customers.firstname + " " + element.customers.lastname;
                }


                //actions string
                let actions_html = ``;
                if(element.status.title == 'Disputed'){
                    actions_html += `<router-link :to="{ name: 'raise-dispute', params: { orderId: `+ element.id + ` }}" class="text-danger">
                                    <small>Raise Dispute</small>
                                    </router-link>&nbsp;&nbsp;`;
                }
                if(this.status != 'no_dispatchers' && element.delivery_men != null){
                   actions_html += `<a style="cursor: pointer;" on-click="showAssignDeliveryManModal(`+element.id+`)" class="text-primary">
                                        <small>Reassign Dispatcher</small>
                                    </a>&nbsp;&nbsp;`; 
                }
                if(this.status != 'no_dispatchers' && element.delivery_men == null){
                   actions_html += `<a style="cursor: pointer;" v-on:click="showAssignDeliveryManModal(order.id)" class="text-primary">
                                        <small>Assign Dispatcher</small>
                                    </a>`; 
                }

                
                               
                let record = {
                    order_id:{
                        row: element.id + "row",
                        unique: element.id + "id",
                        value: this.formatToSixDigits(element.id),
                        editable: false
                    },
                    customer:{
                        unique: element.id + "customer",
                        value: customer_name,
                        editable: false
                    },
                    order_date:{
                        unique: element.id + "date",
                        value: element.transaction_date,
                        editable: false
                    },
                    dispatcher:{
                        unique: element.id + "dispatcher",
                        value: dispatcher_name,
                        editable: false
                    },
                    order_status:{
                        unique: element.id + "status",
                        value: element.status.title,
                        editable: false
                    },
                    action:{
                        unique: element.id + "action",
                        value: element.id,
                        dispatcher_status: this.status,
                        order_status: element.status.title,
                        delivery_men: element.delivery_men,
                        isAction: true,
                        editable: false,
                        isHtml: true
                    }
                };

                returnedArray.push(record);
            }
            //});

            return returnedArray;
            
        },
        hideAlert: function(){
            $(".alert").addClass("d-none");
        },
        formatToSixDigits: function(number){
            var output = number + '';
            while (output.length < 6) {
                output = '0' + output;
            }
            return output;
        },
        getSingleOrderOffline: function(orderId){
            for(var i = 0; i < this.orders.data.length; i++){
                if(this.orders.data[i].id === orderId){
                    return this.orders.data[i];
                }
            }
            return null;
        },
        updateSingleOrderOffline: function(orderId, deliveryManId, deliveryManObject){

            this.order.delivery_man = deliveryManId;
            this.order.delivery_men = deliveryManObject;

            for(var i = 0; i < this.orders.data.length; i++){
                if(this.orders.data[i].id === orderId){
                    this.orders.data[i].delivery_man = deliveryManId;
                    this.orders.data[i].delivery_men = deliveryManObject;
                    return;
                }
            }
        },
        getSellerDispatchers: function(){
            this.$http.get(endpoint +'/seller/deliverymen', { headers: {'Authorization': 'Bearer ' + this.$session.get('trustpayauthtoken') } })
            .then( 
                response => { //success
                    return response.json();
                }, 
                response => { //error
                    this.$router.push('/login');
                }
            )
            .then(dispatcher => { 
                console.log("Dispatchers");
                console.log(dispatcher);
                if(dispatcher.status == "success" && dispatcher.message == "delivery_men" ){
                    this.dispatchers = dispatcher.data
                    this.selectedDispatcher = dispatcher.data[0].id;
                }else{
                    this.status = "no_dispatchers"
                }
                
                }
            );
        },
        showAssignDeliveryManModal: function(orderId){
            this.order = this.getSingleOrderOffline(orderId);
            console.log(this.order);
            $("#assignDispatcherModal").modal('show');
        },
        assignDispatcherToOrder: function(){
            //this.selectedDispatcher;
            //this.order.id;

            this.$http.post( endpoint +'/seller/order/assign', 
                    {
                        "order_id" : this.order.id,
                        "delivery_man_id" : this.selectedDispatcher,
                    }, 
                    { headers: {'Authorization': 'Bearer ' + this.$session.get('trustpayauthtoken') } }
                )
                .then(
                    response => { //success
                        return response.json();
                    }, 
                    response => { //error
                        return response.json();
                    }
            ).then(
                assign => { 
                    console.log(assign); 

                    //show error message in alert box - user is not logged in
                    if(assign.status == "success" && assign.message == "deliveryman_assigned"){
                        //var updatedOrder = this.getSingleOrderOffline(assign.data.id);
                        this.updateSingleOrderOffline(assign.data.id, assign.data.delivery_man, assign.data.delivery_men);
                        //update delivery_man
                        //update delivery_men
                        //for the particluar order 
                        //print success message
                        $(".alert").addClass("d-none");
                        $(".assign-success").removeClass("d-none");

                    }else{
                        this.assignError = assign.message.replace(/\\n/g, " ");
                        $(".alert").addClass("d-none");
                        $(".assign-danger").removeClass("d-none");
                        //print error message

                    }  
                }
            );
        },
        showSingleOrder: function(orderId){
            console.log("Id is - "+orderId);

            var user_role = this.$session.get('stanbic_trustpay_user_role');

            var orderDetailEndpoint = endpoint +'/customer/order';

            if(user_role == "seller"){
                orderDetailEndpoint = endpoint +'/seller/order';
            }

            this.$http.post( orderDetailEndpoint, 
                    {
                        "id" : orderId,
                    }, 
                    { headers: {'Authorization': 'Bearer ' + this.$session.get('trustpayauthtoken') } }
                )
                .then(
                    response => { //success
                        return response.json();
                    }, 
                    response => { //error
                        return response.json();
                    }
            ).then(
                order => { 
                    console.log(order); 

                    //show error message in alert box - user is not logged in
                    if(order.status == "success" && order.message == "order_details"){
                        
                        this.order = order.data;
                        this.order_status = order.data.status; //.title;
                        if(user_role == "buyer"){
                            this.order_seller = order.data.user.firstname + " " + order.data.user.lastname;
                        }else{
                            this.order_seller = order.data.customers.firstname + " " + order.data.customers.lastname;
                        }
                        
                        $("#fullOrderModal").modal('show');

                    }else{

                        alert("Could not retrieve order");

                    }  
                }
            );
        },
    },
    created(){
        var user_role = this.$session.get('stanbic_trustpay_user_role');

        var orderDetailsEndpoint = endpoint +'/customer/orders';

        if(user_role == "seller"){
            orderDetailsEndpoint = endpoint +'/seller/orders';
        }
        console.log("Endpoint - " + orderDetailsEndpoint);
        this.$http.get(orderDetailsEndpoint, { headers: {'Authorization': 'Bearer ' + this.$session.get('trustpayauthtoken') } })
        .then( 
            response => { //success
                return response.json();
            }, 
            response => { //error
                this.$router.push('/login');
            }
        )
        .then(orders => { 
            console.log("orders");
            console.log(orders);
            if(orders.status == "success" && (orders.message == "customer_orders" || orders.message == "orders" || orders.message == "seller_order")){
                console.log(orders);
                this.orders = orders;
                this.original_rows = orders.data;
                this.table_rows = orders.data; //this.populateTableWithData(orders.data);
                console.log("Got here");
                //console.log(this.tableData);

            }else{
                alert("Error. Could not fetch orders at this time");
            }
            
            }
        );
        this.getSellerDispatchers();
        
    },
    beforeCreate: function () {
        console.log(this.$session.get('trustpayauthtoken'));

        var userDetailsEndpoint = endpoint +'/customer';

        if(this.$session.get('stanbic_trustpay_user_role') == "seller"){
            userDetailsEndpoint = endpoint +'/seller/account';
        }

        this.$http.get(userDetailsEndpoint, { headers: {'Authorization': 'Bearer ' + this.$session.get('trustpayauthtoken') } })
        .then( 
            response => { //success
                return response.json();
            }, 
            response => { //error
                this.$router.push('/login');
            }
        )
        .then(user => { 
            if(user.status == "success" && user.message == "customer_details"){
                    this.status = "done";
                    this.fullname = user.data.firstname + " " + user.data.lastname;
                    console.log("stats "+this.status);
                }else if (user.status == "success" && user.message == "seller_details"){
                    
                    this.status = "done";
                    this.fullname = user.data.firstname + " " + user.data.lastname;
                    console.log("stats "+this.status);

                    if(user.data.verified == 0){
                        this.$router.push('/myescrow/verify');
                    }

                }else{
                    this.$session.destroy();
                    alert("Your session has timed out. Please login again");
                    this.$router.push('/login');
                    //this.$router.push('/login');
                }
                
                
        });    
    }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/Orders.vue